import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'
import { connect } from 'react-redux'

import { creditScoreOfferUrlSelector } from 'embed/selectors'
import { defaultCreditScoreUrl } from 'embed/constants/config'
import { getContrastingColor } from 'embed/utils'

import { MultiProductState } from 'embed/reducers'
import EmptyStatePane from './Pane'
import { useTheme } from 'embed/hooks'

const Computer = require('./computer.svg')
const Gauge = require('./gauge.svg')
const Merge = require('./merge.svg')
const styles = require('./styles.scss')

interface StoreProps {
  creditScoreOfferUrl: string | undefined
}

type Pane = 1 | 2 | 3

const EmptyStatesComponent: React.FC<StoreProps> = ({ creditScoreOfferUrl }) => {
  const [showPane, setShowPane] = React.useState<Pane>(1)

  const viewPane = React.useCallback((pane: Pane) => {
    setShowPane(pane)
  }, [])

  const { ctaStyles, colorTextPrimary, colorBorder, borderRadiusLarge, colorTextSecondary, colorPrimary } = useTheme()

  const pane1 = (
    <EmptyStatePane asset={<Gauge />} title="Make sure your credit score is accurate">
      <>
        <p>
          Lenders use your credit score when making you offers. Know what to expect, review your report to get the best
          rates.
        </p>
        <a
          href={creditScoreOfferUrl ?? defaultCreditScoreUrl}
          target="_blank"
          className={classnames(
            styles.emptyStateButton,
            css`
              background-color: ${ctaStyles?.backgroundColor};
              color: ${getContrastingColor(ctaStyles?.backgroundColor, { black: colorTextPrimary })};
              &:hover {
                opacity: 0.84;
              }
            `,
          )}
        >
          Get your free credit score
        </a>
      </>
    </EmptyStatePane>
  )
  const pane2 = (
    <EmptyStatePane asset={<Merge />} title="Consolidating debt?">
      <p>
        If you’re using a personal loan to consolidate credit card debt, make sure you change your spending habits too!
        Set budgets to help keep yourself from spending more than you can afford to keep your finances ship shape.
      </p>
    </EmptyStatePane>
  )
  const pane3 = (
    <EmptyStatePane asset={<Computer />} title="Shopping around?">
      <p>We compare offers personalized for you from the top lenders, saving you time and money!</p>
    </EmptyStatePane>
  )

  const showPane1 = showPane === 1
  const showPane2 = showPane === 2
  const showPane3 = showPane === 3
  const activeClassname = css`
    background-color: ${colorPrimary} !important;
    opacity: 1 !important;
  `
  return (
    <div
      className={classnames(
        styles.emptyStateContainer,
        css`
          border-color: ${colorBorder};
          border-radius: ${borderRadiusLarge};
        `,
      )}
    >
      <div className={styles.controls}>
        <div
          className={classnames(
            styles.control,
            css`
              background-color: ${colorTextSecondary};
            `,
            { [activeClassname]: showPane1 },
          )}
          onClick={() => viewPane(1)}
        />
        <div
          className={classnames(
            styles.control,
            css`
              background-color: ${colorTextSecondary};
            `,
            { [activeClassname]: showPane2 },
          )}
          onClick={() => viewPane(2)}
        />
        <div
          className={classnames(
            styles.control,
            css`
              background-color: ${colorTextSecondary};
            `,
            { [activeClassname]: showPane3 },
          )}
          onClick={() => viewPane(3)}
        />
      </div>
      {showPane1 ? pane1 : null}
      {showPane2 ? pane2 : null}
      {showPane3 ? pane3 : null}
    </div>
  )
}

const mapStateToProps = (state: MultiProductState): StoreProps => ({
  creditScoreOfferUrl: creditScoreOfferUrlSelector(state),
})

export default connect<StoreProps>(mapStateToProps, {})(EmptyStatesComponent)
